import { defineStore } from "pinia";
import axios, { AxiosResponse } from "axios";
import { ContactInfoModel } from "@Shared/Models/ContactInfoModel";

type UserStoreModel = {
  user: ContactInfoModel;
  isAuthenticated: boolean;
};

const baseUrl = `${import.meta.env.VITE_APP_URL}/user`;

export const useUserStore = defineStore({
  id: "user",
  state: (): UserStoreModel => ({
    user: {
      id: 0,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      infoType: "",
      info: "",
    },
    isAuthenticated: false,
  }),
  getters: {
    getUser: (state) => (): ContactInfoModel => {
      return state.user;
    },
  },
  actions: {
    async Get(): Promise<boolean> {
      let path = `${baseUrl}/Get`;
      let response: AxiosResponse;
      try {
        response = await axios.get<ContactInfoModel>(path);
      } catch (error: any) {
        console.log("error", error);
        this.$patch({ isAuthenticated: false });
        return Promise.reject(new Error(error));
      }
      if (response.status === 200) {
        this.$patch({ user: response.data, isAuthenticated: true });
        return Promise.resolve(true);
      }
      return Promise.reject(false);
    },
    async Login(): Promise<void> {
      let path = `${baseUrl}/login`;
      try {
        await axios.get(path);
      } catch (error: any) {
        console.log("error", error);
        this.$patch({ isAuthenticated: false });
        Promise.reject(new Error(error));
      }
    }
  },
});
